<div class="tooltip"
     [ngClass]="['tooltip--'+position]"
     [class.tooltip--visible]="visible"
     [style.left]="left"
     [style.top]="top"
     [style.width]="width">
  {{text}}
</div>